<template>
  <div :class="['age-vehicle-value', { 'disable-app': app.disableApp }]">
    <div class="row">
      <div class="col-xs-12">
        <div class="age-range-select">
          <Select
            :dataTitle="'Din alder'"
            :dataType="'YourAge'"
            :dataItems="selectDataYourAge"
            :selected-value="app.userInfo.ageRange.value"
            v-on:childToParent="yourAgeChange"
            :validateText="validateShow && !app.userInfo.ageRange.value ? 'Skal udfyldes' : ''"
          />

          <span
            class="c-info-hover"
            v-if="app.disableApp && disableAppText.helpTitle && disableAppText.helpTextHtml"
          >
            <button
              class="c-info-hover__button"
              @click.prevent="disableAppinfoClick(true)"
            ></button>
            <span
              :class="[
                { 'c-info-hover__box--is-shown': disableAppText.showInfo },
                'c-info-hover__box'
              ]"
              @click.prevent
            >
              <button class="c-info-hover__close" @click.prevent="disableAppinfoClick(false)">
                Luk
              </button>
              <span class="c-info-hover__text">
                <h4 class="c-info-hover__title">
                  {{ disableAppText.helpTitle }}
                </h4>
                <span v-html="disableAppText.helpTextHtml"></span>
              </span>
            </span>
          </span>
        </div>
      </div>

      <div class="col-xs-12">
        <Checkbox 
          v-if="app.userInfo.ageRange.value == '25-29' || app.userInfo.ageRange.value == '30'"
          :dataText="'+3 år skadefri'"
          :dataType="'isElite'"
          :dataChecked="app.ins.isElite"
          v-on:childToParent="isEliteChange"
         />
      </div>







      <div class="col-xs-12">
        <Select
          :dataTitle="'Nyværdi*'"
          :dataType="'VehicleValueNew'"
          :dataItems="selectDataVehicleValueNew"
          :selected-value="app.ins.newCarPrice.selectedvalue"
          v-on:childToParent="vehicleValueNewChange"
          :disabled="app.conditions.lockdownCarPrice.activated == true"
          :validateText="validateShow && !app.ins.newCarPrice.selectedvalue ? 'Skal udfyldes' : ''"
        />
        <Paragraph
          :dataParagraph="
            '*Nyværdi er listeprisen for bilen som fabriksny. Vær obs på at der kan være forskel på listeprisen og det du har betalt for bilen. Nyværdien er inkl. danske afgifter'
          "
        />
        <Paragraph
          :dataParagraph="'**Forsikringen formidles af WIA I/S og Gjensidige Forsikring'"
        />
      </div>

      <div class="col-xs-12 mt-15">
          <InputText
            style="width: 100%;"
            :dataText="postalCodeText"
            :dataTitle="'Postnummer*'"
            :dataType="'ZipCode'"
            :dataInputType="'text'"
            :dataInputPattern="'^[0-9]{4}$'"
            :dataInputSize="10"
            :isRequired="true"
            v-on:childToParent="postalCodeChange"
            :dataNote="
              ''
            "
           :restrictedToLength="4"
           :restrictedToNumbers="true"
            :validateShow="validateShow"
            :validateText="'Indtast venligst et gyldigt postnummer'" />
      </div>



      
      <div class="col-xs-12">
        <SelectLicense
          :checked="app.ins.selectlicenseFor3Years"
          :value="app.ins.selectlicenseFor3Years"
          :title="'Jeg har haft kørekort i 3 år eller mere'"
          :valid="
            validateShow &&
              (this.app.userInfo.ageRange.value != '18-20'
                ? !this.app.ins.selectlicenseFor3Years
                : false)
          "
          :show="app.userInfo.ageRange.value != '18-20'"
          v-on:childToParent="selectlicenseFor3Years"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('app');
import Select from '@/components/select/select.vue';
import SelectLicense from '@/components/select-license/select-license.vue';
import { staticData } from '@/helper/staticData.js';
import Paragraph from '@/components/paragraph/paragraph.vue';
import InputText from '@/components/input-text/input-text.vue';
import Checkbox from '@/components/checkbox/checkbox.vue';

// @ is an alias to /src
export default {
  name: 'AgeAndVehicleValue',
  components: {
    Select,
    SelectLicense,
    Paragraph,
    InputText,
    Checkbox
  },
  computed: {
    ...mapGetters(['app'])
  },
  data() {
    return {
      postalCodeText:'',
      disableAppText: {
        helpTitle: 'helpTitle',
        helpTextHtml: 'helpTextHtml',
        showInfo: false
      },
      pageIsValid: false,
      disableBtn: false,
      selectDataYourAge: staticData.step1.selectDataYourAge,
      selectDataYearsWithoutDamage: [],
      selectDataVehicleValueNew: staticData.step1.selectDataVehicleValueNew
    };
  },
  methods: {
    disableAppinfoClick(mode) {
      this.disableAppText.showInfo = mode;
    }, 
    postalCodeChange(item) {
      this.$store.dispatch('app/postalCode', item);
      this.$emit('childToParent', {postalCode:'change'});
    },
    isEliteChange(item) {
      this.$store.dispatch('app/isElite', item);
      this.$emit('childToParent', true);
    },
    selectlicenseFor3Years(item) {
      this.$store.dispatch('app/selectlicenseFor3Years', item.target.checked);
      this.$emit('childToParent', true);
    },

    yourAgeChange(item) {
      const ageRangeIsElite = ['25-29', '30'];
      if (ageRangeIsElite.includes(item.value) === false) {
        this.$store.dispatch('app/isElite', false);
      }
    if (item.value == '18-20') {
        this.$store.dispatch('app/selectlicenseFor3Years', false);
      }
      this.showLicenseFor3YearsAfterAgeRangeSelect = true;
      this.$store.dispatch('app/age', item);
      this.$emit('childToParent', true);
    },
    vehicleValueNewChange(item) {
      this.$store.dispatch('app/vehicleAndCarTypeValue', item);
      this.$emit('childToParent', true);
    }
  },
  mounted() {
    this.$store.dispatch('app/loading', false);
  },
  beforeMount() {
    if (this.app.isAM) {
      this.postalCodeText = 2860;
    }
  },
  props: {
    validateShow: Boolean
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
@import './age-vehicle-value';


</style>
